export enum FilterPurpose {
    undefined = 0,
    userList = 1,
    productList = 2
}
